import { useQuery } from '@tanstack/react-query'
import { api, CollectionsResponse } from '../services/api'

export const useCollections = () => {
  return useQuery<CollectionsResponse>({
    queryKey: ['collections'],
    queryFn: api.getCollections,
  })
}